(function () {
  var el = document.getElementById('js-product-mv-catch');
  if (!el) return;

  var params = new URLSearchParams(window.location.search);
  var paramValue = params.get('copy') || '';
  
  if (!paramValue) return;

  // セクションIDを取得（親要素から）
  var section = el.closest('.product-mv');
  if (!section) return;
  
  var sectionId = '';
  var classList = section.className.split(' ');
  for (var i = 0; i < classList.length; i++) {
    if (classList[i].indexOf('product-mv--') === 0) {
      sectionId = classList[i].replace('product-mv--', '');
      break;
    }
  }
  
  if (!sectionId) return;

  // JSONから設定を取得
  var jsonEl = document.getElementById('product-mv-parameter-map-' + sectionId);
  if (!jsonEl) return;

  var map = {};
  try {
    var jsonData = JSON.parse(jsonEl.textContent);
    if (jsonData[sectionId]) {
      map = jsonData[sectionId];
    }
  } catch (e) {
    console.error('Failed to parse parameter map:', e);
    return;
  }

  // URLパラメータに一致するテキストがあれば適用
  var key = paramValue.toUpperCase();
  if (map[key]) {
    // 改行を<br>タグに変換
    var text = map[key];
    text = text.replace(/\n/g, '<br>');
    el.innerHTML = text;
  }
})();
